
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/mediaplayer/networking",
      function () {
        return require("private-next-pages/admin/mediaplayer/networking.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/mediaplayer/networking"])
      });
    }
  